import undoable from 'redux-undo';

const initialState = {
  pageLoading: 0, // This is the current loading status of the application
  elementToEdit: null, // Element to load in the blocksettings
  currentPage: 'home', // Current page
  savedPage: true, // Saved page status
  saveAlert: null, // Product is to load after saving
  elementOptions: null, // Element options
  palettes: null, // Palettes of the app

  fetchedPages: [], // All fetched pages and layouts
  fetchedPayloads: {}, // All fetched payloads ['topbar','footer']
  fetchedProducts: {}, // All fetched products
  fetchedCategories: {}, // All fetched categories
  fetchedMenu: [], // The fetched menu
  fetchedThemes: [], // All fetched themes
  fetchedLangs: [], // All fetched langs,
  currentLang: null, //

  historying: false, // Enable saving history

  currentDevice: 'xl', // Screen size for devices
  translatedStrings: {}, // Translated string
  toCopy: null, // Element to copy
  blockToCopy: null, // Block to copy
  draggedElement: null, // Dragged element
  storeLogo: null, // Store logo
  templates: null, // Pages templates
  appearanceSettings: null, // Appearance settings Global
  pageStack: ['home'], // page stack for go back functionality
  showBlockSettings: false, // for wisywig
  showSideBar: true, //auto hide when drag
  header: null, // header data will be saved here only
  themeThumbList: null, // to store thumb images of each store
  currentTheme: null, // current theme name
  recentColors: [],
  openFloatElementSettings: false,
  alwaysOpenStyle: false,
  showGlobalList: true,
};

export const rootReducer = (state = initialState, action) => {
  if (action.type === 'SET_SHOW_GLOBALE_LIST') {
    return { ...state, showGlobalList: action.show };
  }
  if (action.type === 'SET_ALWAYS_OPEN') {
    return { ...state, alwaysOpenStyle: action.open };
  }
  if (action.type === 'SET_FLOAT_SETTINGS_OPEN') {
    return {
      ...state,
      openFloatElementSettings: action.openFloatElementSettings,
    };
  }
  if (action.type === 'ADD_RECENT_COLOR') {
    const colors = [...state.recentColors.filter((color) => color !== action.color), action.color];
    return { ...state, recentColors: colors };
  }
  if (action.type === 'CURRENT_THEME') {
    return { ...state, ...{ currentTheme: action.currentTheme } };
  }
  if (action.type === 'ADD_THEME_THUMB') {
    return {
      ...state,
      ...{
        themeThumbList: {
          ...state.themeThumbList,
          [action.data.themeName]: action.data.url,
        },
      },
    };
  }
  if (action.type === 'SET_HEADER_DATA') {
    return { ...state, ...{ header: action.header } };
  }
  if (action.type === 'SET_SHOW_SIDEBAR') {
    return { ...state, ...{ showSideBar: action.showSideBar } };
  }
  if (action.type === 'LOAD_INCREMENT') return { ...state, ...{ pageLoading: state.pageLoading + action.toAdd } };
  if (action.type === 'EDIT_ELEMENT') {
    window.dispatchEvent(new Event('resize'));
    return { ...state, ...{ elementToEdit: action.element } };
  }
  if (action.type === 'SET_CURRENTPAGE') return { ...state, ...{ currentPage: action.value } };
  if (action.type === 'SET_SAVEDPAGE') return { ...state, ...{ savedPage: action.savedPage } };
  if (action.type === 'SET_SAVEALERT') return { ...state, ...{ saveAlert: action.value } };

  if (action.type === 'HISTORYING') return { ...state, ...{ historying: action.bool } };

  if (action.type === 'SET_ELEMENTOPTIONS') return { ...state, ...{ elementOptions: action.value } };
  if (action.type === 'SET_PALETTES') return { ...state, ...{ palettes: action.value } };

  if (action.type === 'LIST_PAGES') return { ...state, ...{ fetchedPages: action.pages } };
  if (action.type === 'LIST_PAYLOAD')
    return {
      ...state,
      ...{
        fetchedPayloads: {
          ...state.fetchedPayloads,
          ...{ [action.target]: action.value },
        },
      },
    };
  if (action.type === 'LIST_PRODUCTS') return { ...state, ...{ fetchedProducts: action.products } };
  if (action.type === 'LIST_CATEGORIES')
    return {
      ...state,
      ...{
        fetchedCategories: {
          ...state.fetchedCategories,
          ...{ [action.target]: action.categories },
        },
      },
    };
  if (action.type === 'LIST_THEMES') return { ...state, ...{ fetchedThemes: action.themes } };
  if (action.type === 'SET_MENU') return { ...state, ...{ fetchedMenu: action.menu } };

  if (action.type === 'LIST_LANGS') return { ...state, ...{ fetchedLangs: action.langs } };
  if (action.type === 'SET_CURRENTLANG') return { ...state, ...{ currentLang: action.lang } };

  if (action.type === 'SET_DEVICE') return { ...state, ...{ currentDevice: action.device } };
  if (action.type === 'TRANSLATE') return { ...state, ...{ translatedStrings: action.object } };

  if (action.type === 'COPY') return { ...state, ...{ toCopy: action.toCopy } };
  if (action.type === 'COPY_BLOCK') return { ...state, ...{ blockToCopy: action.blockToCopy } };

  if (action.type === 'DRAG_ELEMENT') return { ...state, ...{ draggedElement: action.element } };

  if (action.type === 'STORE_LOGO') return { ...state, ...{ storeLogo: action.url } };

  if (action.type === 'LIST_TEMPLATES') return { ...state, ...{ templates: action.templates } };

  if (action.type === 'SET_APPEARANCE') return { ...state, ...{ appearanceSettings: action.settings } };
  if (action.type === 'SET_SHOW_EYE') return { ...state, ...{ previewUrl: action.url } };
  if (action.type === 'ADD_PAGE_TO_STACK') return { ...state, ...{ pageStack: [...state.pageStack, action.page] } };
  if (action.type === 'POP_FROM_PAGE_STACK') {
    return { ...state, ...{ pageStack: [...action.pageStack] } };
  }

  if (action.type === 'SHOW_BLOCK_SETTINGS') return { ...state, ...{ showBlockSettings: action.showBlockSettings } };
  return state;
};

const undoReducer = (state = { currentPayload: [] }, action) => {
  if (action.type === 'UPDATE_PAYLOADHISTORY') return { ...state, ...{ currentPayload: action.payload } };

  return state;
};

export const undo = undoable(undoReducer);
